<div class="dx-page-header" *ngIf="options">

  <ng-container *ngIf="options.groups">
    <!-- Генерирование групп элементов заголовка -->
    <div class="dx-page-header__part" *ngFor="let group of options.groups">
      <!-- Генерирование итемов заголовка в рамках группы -->
      <ng-container *ngFor="let item of group.items">
        <div class="dx-page-header__item">

          <!-- TODO: На подумать. Пока оставляю такую реализацию, так как встраивание реализации для, напрмер, -->
          <!-- TODO: setting, help, notifications, комбиков в шапку предполагает уже что-то конкретное и осязаемое. -->
          <!-- TODO: С одной стороны содержание справки, настроек +- типичны от приложения к приложению и их можно реализовать тут. -->
          <!-- TODO: Однако, тогда нужно изобретать универсальные механизм конфигурирования\предоставления источников данных. -->
          <!-- TODO: В это все можно забурится надолго. Поэтому, возможно переделаю в последствие. -->
          <!-- TODO: Из этих же соображений оставлена портянка с кучей директив.  -->
          <!-- TODO: В нижнем пределе все выглядит одинаково, но если начать вносит логику хэдер, то лучше иметь отдельные директивы.  -->
          <ng-container [ngSwitch]="item.type">
            <!-- Лого приложения -->
            <ng-container *ngSwitchCase="'APP_LOGO'">
              <ng-container *ngTemplateOutlet="pageHeaderAppLogoTemplate || defaultPageHeaderAppLogoTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Название приложения -->
            <ng-container *ngSwitchCase="'APP_NAME'">
              <ng-container *ngTemplateOutlet="pageHeaderAppTitleTemplate || defaultPageHeaderAppTitleTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Функциональная кнопка -->
            <ng-container *ngSwitchCase="'TOOL_BUTTON'">
              <ng-container *ngTemplateOutlet="findHeaderComboTemplate(item) || defaultPageHeaderComboTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Выпадающий список в заголовке -->
            <ng-container *ngSwitchCase="'COMBO'">
              <!--<ng-container *ngIf="findHeaderComboTemplates(item) as template; else defaultPageHeaderComboTemplate">
                <ng-container *ngTemplateOutlet="template; context: buildHeaderItemContext(item)"></ng-container>
              </ng-container>-->
              <ng-container *ngTemplateOutlet="findHeaderToolBtnTemplate(item) || defaultPageHeaderComboTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Контейнер под элементы навигации -->
            <ng-container *ngSwitchCase="'NOTIFICATION_BAR'">
              <ng-container *ngTemplateOutlet="pageHeaderNotificationBarTemplate || defaultPageHeaderNotificationBarTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Контейнер под элементы навигации -->
            <ng-container *ngSwitchCase="'SETTINGS_BAR'">
              <ng-container *ngTemplateOutlet="pageHeaderSettingsBarTemplate || defaultPageHeaderSettingsBarTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Контейнер под элементы навигации -->
            <ng-container *ngSwitchCase="'HELP_BAR'">
              <ng-container *ngTemplateOutlet="pageHeaderHelpBarTemplate || defaultPageHeaderHelpBarTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Контейнер под элементы навигации -->
            <ng-container *ngSwitchCase="'NAVIGATION_BAR'">
              <ng-container *ngTemplateOutlet="pageHeaderNavBarTemplate || defaultPageHeaderNavBarTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Контейнер под информацию о текущем пользователе -->
            <ng-container *ngSwitchCase="'USER_BAR'">
              <ng-container *ngTemplateOutlet="pageHeaderUserBarTemplate || defaultPageHeaderUserBarTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

            <!-- Контейнер под функционал для выхода из системы -->
            <!-- Кнопка в переделе или выпадающий список действий -->
            <ng-container *ngSwitchCase="'LOGOUT_BAR'">
              <ng-container *ngTemplateOutlet="pageHeaderLogoutBarTemplate || defaultPageHeaderLogoutBarTemplate; context: buildHeaderItemContext(item)"></ng-container>
            </ng-container>

          </ng-container>
        </div>

        <!-- Отделяем итем сепаратором от следующего если это требуется -->
        <div class="dx-page-header__separator" *ngIf="item.addSeparatorAfter"></div>

      </ng-container>

    </div>
  </ng-container>

  <!-- ДЕФОЛТНЫЕ ШАБЛОНЫ ДЛЯ ЭЛЕМЕНТОВ ЗАГОЛОВКА -->

  <!-- Дефолтный контейнер с местом под лого приложения. -->
  <!-- В принципе переопределять этот кусок большого смысла нет -->
  <ng-template #defaultPageHeaderAppLogoTemplate let-item>
    <a class="dx-page-header__logo" (click)="onAppLogoClick()">
      <img [src]="item.iconPath"  alt="">
    </a>
  </ng-template>

  <!-- Дефолтный контейнер под название системы -->
  <!-- В принципе переопределять этот кусок большого смысла нет -->
  <ng-template #defaultPageHeaderAppTitleTemplate let-item>
    <div class="dx-page-header__app_title">
      <ng-container *ngIf="item.multiLineTitle; else singleLineTitle">
        <div class="dx-page-header__app_title_line" *ngFor="let titleLine of item.multiLineTitle">{{titleLine}}</div>
      </ng-container>
      <ng-template #singleLineTitle>
        <div class="dx-page-header__app_title_line">{{item.title}}</div>
      </ng-template>
    </div>
  </ng-template>

  <!-- Дефолтный контейнер под комбик -->
  <ng-template #defaultPageHeaderComboTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>

  <!-- Дефолтный контейнер по функциональную кнопку -->
  <ng-template #defaultPageHeaderToolBtnTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>


  <!-- В контексте ядра нижеследующие шаблоны существуют только для переопределения -->
  <!-- так как их содержимое несет сугубо прикладной характер -->
  <!-- Здесь они нужны для обозначения общей структуры заголовка и механизма переопределения -->

  <!-- Дефолтный контейнер под навигацию в шапке (например хлебные крошки) -->
  <ng-template #defaultPageHeaderNavBarTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>

  <!-- Дефолтный контейнер для блока уведомлений -->
  <ng-template #defaultPageHeaderNotificationBarTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>

  <!-- Дефолтный контейнер для блока настроек системы -->
  <ng-template #defaultPageHeaderSettingsBarTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>

  <!-- Дефолтный контейнер для блока справки\помощи системы -->
  <ng-template #defaultPageHeaderHelpBarTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>


  <!-- Дефолтный контейнер для блока с информацией о пользовате -->
  <ng-template #defaultPageHeaderUserBarTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>

  <!-- Дефолтный контейнер под функционал для выхода из системы -->
  <ng-template #defaultPageHeaderLogoutBarTemplate let-item>
    <div class="dx-page-header__item_content">{{item.title}}</div>
  </ng-template>

</div>
